// Eudonet preset filter catalog for the projects page. Each preset is a single filter
// criterion shown as a checkbox in the "Eudonet" group of the "Mes listes" dropdown; the
// user checks one or more and clicks "Créer la liste" to create a custom list whose filter
// is their combination. The same presets back the status quick tabs.
export const PROJECT_VIEW_PRESETS = [
    { id: "idea", labelKey: "projects.status.Idea", filterKey: "status", value: "Idea" },
    { id: "inprogress", labelKey: "projects.status.InProgress", filterKey: "status", value: "InProgress" },
    { id: "suspended", labelKey: "projects.status.Suspended", filterKey: "status", value: "Suspended" },
    { id: "closed", labelKey: "projects.status.Closed", filterKey: "status", value: "Closed" },
    { id: "archived", labelKey: "projects.status.Archived", filterKey: "status", value: "Archived" },
];
const PRESET_BY_ID = new Map(PROJECT_VIEW_PRESETS.map((p) => [p.id, p]));
/**
 * i18n label key for a (filterKey, value) pair — used to auto-name a saved list from its
 * filters ("Idée / montage + En cours"). Status is the only filter dimension today; an
 * unknown key falls back to the value-derived `projects.{filterKey}.{value}` key so a
 * future dimension degrades to a raw-key label instead of crashing.
 */
export function filterValueLabelKey(filterKey, value) {
    return `projects.${filterKey}.${value}`;
}
/**
 * Builds a table query snapshot from a set of preset ids, grouping by filter key
 * (two statuses become `status in [a, b]`). Unknown ids are ignored.
 */
export function buildPresetQuerySnapshot(presetIds) {
    const filters = {};
    for (const id of presetIds) {
        const preset = PRESET_BY_ID.get(id);
        if (!preset)
            continue;
        const existing = filters[preset.filterKey];
        if (existing) {
            if (!existing.values.includes(preset.value))
                existing.values.push(preset.value);
        }
        else {
            filters[preset.filterKey] = { type: "in", values: [preset.value] };
        }
    }
    return { filters };
}
